/* eslint-disable react-dom/no-dangerously-set-innerhtml */
import React from 'react'

import { script } from './script'

import { USER_INFO_KEY } from '@/contexts/AuthContext/hooks/userCookie'

export interface CoreDataScriptProps {}

const CoreDataScript: React.FC<CoreDataScriptProps> = () => {
  const userValidReg =
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? new RegExp(
          `(${USER_INFO_KEY.replace(/\$/, '\\$')})={.*"email":"(.+?)".*}`,
        )
      : new RegExp(
          `${USER_INFO_KEY.replace(/([[\]])/g, '\\$1')}={.*"email":"(.+?)".*}`,
        )

  return (
    <script
      suppressHydrationWarning
      dangerouslySetInnerHTML={{
        __html: `(${script.toString()})(${userValidReg.toString()})`,
      }}
    />
  )
}

export default CoreDataScript
